import Attribution from '@web-solutions/module-attribution';

import { init as initRemoteConfig } from '@web-solutions/core/store/remote-config/actions';
import { initAppLink, setLoaded } from '@web-solutions/base-app/store/app/actions';

import { init as initRouting } from '@web-solutions/base-app/store/routing/actions';
import { auth } from '@web-solutions/base-app/store/profile/actions';
import { applyTheme } from '@web-solutions/core/utils/theme';
import { createRemoteConfigValidator } from '@web-solutions/core/utils/remote-config-validation';

import { setSteps } from '@web-solutions/core/upsale/store';

import { APP_LINKS } from 'src/constants/general';
import { ALLOWED_EMPTY_CONFIG_PATHS, INITIAL_CONFIG } from 'src/constants/remote-config';

import getLocale from 'src/localization/get-locale';
import { setLocale } from 'src/localization/store';

import { getMagnusToken } from './utils';

const validateRemoteConfig = createRemoteConfigValidator(ALLOWED_EMPTY_CONFIG_PATHS);

export const load = () => async (dispatch, getState) => {
  try {
    dispatch(auth());

    await dispatch(
      initRemoteConfig(process.env.REACT_APP_MAGNUS_TOKEN, INITIAL_CONFIG, {
        validate: validateRemoteConfig,
      }),
    );

    Attribution.init(APP_LINKS);

    const state = getState();
    const theme = state?.remoteConfig?.theme;
    const upsaleRoutes = state?.remoteConfig?.upsaleRoutes;

    if (theme) {
      applyTheme(theme);
    }

    await dispatch(initRouting());
    await dispatch(initAppLink());
    await dispatch(setSteps(upsaleRoutes || []));

    const localizationEnabled = state?.remoteConfig?.localizationEnabled;
    if (localizationEnabled) {
      const locale = getLocale();
      dispatch(setLocale(locale));
      console.log('locale', locale);
      const currentLanguage = locale || 'en';
      const isRtl = ['ar'].includes(currentLanguage);

      document.documentElement.lang = currentLanguage;
      document.documentElement.dir = isRtl ? 'rtl' : 'ltr';
    }
  } catch (error) {
    console.warn('[ERROR INIT APP]', error);
  } finally {
    dispatch(setLoaded(true));
  }
};
